import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Colors } from "../Colors/Colors";

function ConfirmDeleteDialog({ content, handleCancelDelete, handleConfirmDelete }) {
  return (
    <Dialog
      title={"Confirm"}
      onClose={handleCancelDelete}
    >
      <p style={{ margin: "25px", textAlign: "center", fontSize: 16 }}>
        Are you sure you want to delete this {content}?
      </p>
      <DialogActionsBar>
        <Button
          className="k-button"
          name={`btnDeleteDialogNo`}
          style={{ backgroundColor: Colors.secondary }}
          onClick={handleCancelDelete}
        >
          No
        </Button>
        <Button
          className="k-button"
          name={`btnDeleteDialogYes`}
          style={{ backgroundColor: Colors.error }}
          onClick={handleConfirmDelete}
        >
          Yes
        </Button>
      </DialogActionsBar>
    </Dialog>
  );
}

export default ConfirmDeleteDialog;
